export const termsOfServiceHtml = `<!doctype html>
<html xmlns:og="http://opengraphprotocol.org/schema/" xmlns:fb="http://www.facebook.com/2008/fbml" lang="en-US">
  <head>
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <!-- This is Squarespace. -->
    <!-- lobster-reed-cf94 -->
    <base href="" />
    <meta charset="utf-8" />
    <title>Terms of Service &mdash; REFORM IS COMING</title>
    <meta http-equiv="Accept-CH" content="Sec-CH-UA-Platform-Version, Sec-CH-UA-Model" />
    <link rel="icon" type="image/x-icon" href="https://assets.squarespace.com/universal/default-favicon.ico" />
    <link rel="canonical" href="https://www.thereligionbusiness.com/terms-of-service" />
    <meta property="og:site_name" content="REFORM IS COMING" />
    <meta property="og:title" content="Terms of Service &mdash; REFORM IS COMING" />
    <meta property="og:url" content="https://www.thereligionbusiness.com/terms-of-service" />
    <meta property="og:type" content="website" />
    <meta itemprop="name" content="Terms of Service — REFORM IS COMING" />
    <meta itemprop="url" content="https://www.thereligionbusiness.com/terms-of-service" />
    <meta name="twitter:title" content="Terms of Service — REFORM IS COMING" />
    <meta name="twitter:url" content="https://www.thereligionbusiness.com/terms-of-service" />
    <meta name="twitter:card" content="summary" />
    <meta name="description" content="" />
    <link rel="preconnect" href="https://images.squarespace-cdn.com" />
    <link rel="preconnect" href="https://use.typekit.net" crossorigin />
    <link rel="preconnect" href="https://p.typekit.net" crossorigin />
    <script
      type="text/javascript"
      src="//use.typekit.net/ik/Fy1TlTaDmRSu3rJ9sNtAdFq2ud8XzqFf8ipLPlRMi8qfe7SIfFHN4UJLFRbh52jhWDjuwQBywcFKwABy5AZKFAJXFRMhwRjtjs7LMkG0jAFu-WsoShFGZAsude80ZkoRdhXCHKoyjamTiY8Djhy8ZYmC-Ao1Oco8if37OcBDOcu8OfG0deNKSas8SKukZAmqOAFc5Qb0SaBujW48Sagyjh90jhNlOfG0SaBujW48SagyjhmDjhy8ZYmC-Ao1OcFzdPUyjamTiY8Djhy8ZYmC-Ao1OcFzdPUyjamTiY8Djhy8ZYmC-Ao1Oco8ifUySkolZPUCdh4DiemkOW48ZAbljhjoFfoDSWmyScmDSeBRZPoRdhXCdeNRjAUGdaFXOYFUiABkZWF3jAF8ShFGZAsude80ZkoRdhXCiey8ScmC-AiTdhoKiWFTdcmDSkoRdhXCiaiaOcBRiA8XpWFR-emqiAUTdcS0jhNlOYiaikoyjamTiY8Djhy8ZYmC-Ao1Oco8ifUaiaS0jWw0dA9CiaiaOcUzj1FXZWJlScm8ZfuRZRqXO1FUiABkZWF3jAF8OcFzdPUaiaS0SaBujW48SagyjhmDjhy8ZYmC-Ao1OcFzdPUaiaS0iey8ScmC-AiTdhoKiWFTdcmDSkoRdhXK2hyydY8yScblZe8DSeUypPGHf5P5MyMMeMJ6MKGHf5A5MyMMeMw6MKGHf5h5MyMMeMS6MKGHf555MyMMeM36MKGHf5-5MyMMeMX6MKGHf5E5MyMMegI6MTMg7HaP7Mj.js"></script>
    <script type="text/javascript">
      try {
        Typekit.load();
      } catch (e) {}
    </script>
    <script
      type="text/javascript"
      crossorigin="anonymous"
      defer="true"
      nomodule="nomodule"
      src="//assets.squarespace.com/@sqs/polyfiller/1.6/legacy.js"></script>
    <script
      type="text/javascript"
      crossorigin="anonymous"
      defer="true"
      src="//assets.squarespace.com/@sqs/polyfiller/1.6/modern.js"></script>
    <script type="text/javascript">
      SQUARESPACE_ROLLUPS = {};
    </script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/extract-css-runtime-af6822c878021ad34e65-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-extract_css_runtime');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/extract-css-runtime-af6822c878021ad34e65-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/extract-css-moment-js-vendor-c4d588d4255cd4c70fa3-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-extract_css_moment_js_vendor');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/extract-css-moment-js-vendor-c4d588d4255cd4c70fa3-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/cldr-resource-pack-0c96ad3f9948c3a7b631-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-cldr_resource_pack');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/cldr-resource-pack-0c96ad3f9948c3a7b631-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/common-vendors-stable-2965e1fc774101038a7d-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-common_vendors_stable');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/common-vendors-stable-2965e1fc774101038a7d-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/common-vendors-8921de8f24d51c37e1bd-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-common_vendors');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/common-vendors-8921de8f24d51c37e1bd-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/common-4575fb66a4f368aae0d1-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-common');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/common-4575fb66a4f368aae0d1-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/performance-daea797f26ec33aee348-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-performance');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/performance-daea797f26ec33aee348-min.en-US.js"
      defer></script>
    <script data-name="static-context">
      Static = window.Static || {};
      Static.SQUARESPACE_CONTEXT = {
        betaFeatureFlags: [
          'campaigns_thumbnail_layout',
          'campaigns_import_discounts',
          'themes',
          'member_areas_feature',
          'marketing_landing_page',
          'campaigns_new_image_layout_picker',
          'contacts_and_campaigns_redesign',
          'override_block_styles',
          'new_stacked_index',
          'marketing_automations',
          'campaigns_discount_section_in_blasts',
          'supports_versioned_template_assets',
          'i18n_beta_website_locales',
          'campaigns_discount_section_in_automations',
          'nested_categories',
          'scripts_defer',
          'collection_typename_switching'
        ],
        facebookAppId: '314192535267336',
        facebookApiVersion: 'v6.0',
        rollups: {
          'squarespace-announcement-bar': {
            js: '//assets.squarespace.com/universal/scripts-compressed/announcement-bar-e58c2c256fc771df196f-min.en-US.js'
          },
          'squarespace-audio-player': {
            css: '//assets.squarespace.com/universal/styles-compressed/audio-player-7273fb3c727315fb7087-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/audio-player-73979cf5715b90ec9b51-min.en-US.js'
          },
          'squarespace-blog-collection-list': {
            css: '//assets.squarespace.com/universal/styles-compressed/blog-collection-list-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/blog-collection-list-3b161a94b70c22562b65-min.en-US.js'
          },
          'squarespace-calendar-block-renderer': {
            css: '//assets.squarespace.com/universal/styles-compressed/calendar-block-renderer-45e10dd8aac6cdf250c5-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/calendar-block-renderer-8aa9b0cbeb4b1382de47-min.en-US.js'
          },
          'squarespace-chartjs-helpers': {
            css: '//assets.squarespace.com/universal/styles-compressed/chartjs-helpers-035fad01719b3ad44ea0-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/chartjs-helpers-87bcc1cf71dc32506780-min.en-US.js'
          },
          'squarespace-comments': {
            css: '//assets.squarespace.com/universal/styles-compressed/comments-8d82b7dcc10a49d8f3ab-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/comments-1ba83c0b3b745fb75907-min.en-US.js'
          },
          'squarespace-custom-css-popup': {
            css: '//assets.squarespace.com/universal/styles-compressed/custom-css-popup-42165bae3117a373beba-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/custom-css-popup-9fd142ac50a77a92eb80-min.en-US.js'
          },
          'squarespace-dialog': {
            css: '//assets.squarespace.com/universal/styles-compressed/dialog-4442f8c03c49894df614-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/dialog-3c204698eb988e00b67c-min.en-US.js'
          },
          'squarespace-events-collection': {
            css: '//assets.squarespace.com/universal/styles-compressed/events-collection-45e10dd8aac6cdf250c5-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/events-collection-ab0904713c7bec57a263-min.en-US.js'
          },
          'squarespace-form-rendering-utils': {
            js: '//assets.squarespace.com/universal/scripts-compressed/form-rendering-utils-9dbd9ab8f7fe48dd0912-min.en-US.js'
          },
          'squarespace-forms': {
            css: '//assets.squarespace.com/universal/styles-compressed/forms-561e399da7e8cd21136e-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/forms-460e44eec8302ce495d5-min.en-US.js'
          },
          'squarespace-gallery-collection-list': {
            css: '//assets.squarespace.com/universal/styles-compressed/gallery-collection-list-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/gallery-collection-list-6a695d6f503d6f274456-min.en-US.js'
          },
          'squarespace-image-zoom': {
            css: '//assets.squarespace.com/universal/styles-compressed/image-zoom-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/image-zoom-86a4f1190d4dd0a1bb85-min.en-US.js'
          },
          'squarespace-pinterest': {
            css: '//assets.squarespace.com/universal/styles-compressed/pinterest-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/pinterest-4db8797e0ab9916b74bc-min.en-US.js'
          },
          'squarespace-popup-overlay': {
            css: '//assets.squarespace.com/universal/styles-compressed/popup-overlay-1953548b82872bd9f153-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/popup-overlay-abef1bd20e88ee2b0ff6-min.en-US.js'
          },
          'squarespace-product-quick-view': {
            css: '//assets.squarespace.com/universal/styles-compressed/product-quick-view-cabe0d0e788aff914259-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/product-quick-view-ae1191dd37ba355c2d16-min.en-US.js'
          },
          'squarespace-products-collection-item-v2': {
            css: '//assets.squarespace.com/universal/styles-compressed/products-collection-item-v2-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/products-collection-item-v2-bc54407b17c1344e3754-min.en-US.js'
          },
          'squarespace-products-collection-list-v2': {
            css: '//assets.squarespace.com/universal/styles-compressed/products-collection-list-v2-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/products-collection-list-v2-320bbe708a4fc56f6d2e-min.en-US.js'
          },
          'squarespace-search-page': {
            css: '//assets.squarespace.com/universal/styles-compressed/search-page-efbf373f59490877e106-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/search-page-070b8b054bdeaedce608-min.en-US.js'
          },
          'squarespace-search-preview': {
            js: '//assets.squarespace.com/universal/scripts-compressed/search-preview-ad37c6d6b6aef9eab4d8-min.en-US.js'
          },
          'squarespace-simple-liking': {
            css: '//assets.squarespace.com/universal/styles-compressed/simple-liking-87ea620354232c2e7b9f-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/simple-liking-b240c4039cac2761e6d0-min.en-US.js'
          },
          'squarespace-social-buttons': {
            css: '//assets.squarespace.com/universal/styles-compressed/social-buttons-7430c3ff0790eafdec2c-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/social-buttons-1eefd456ab26aca444a7-min.en-US.js'
          },
          'squarespace-tourdates': {
            css: '//assets.squarespace.com/universal/styles-compressed/tourdates-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/tourdates-6a57cd3d6dd5f8c36147-min.en-US.js'
          },
          'squarespace-website-overlays-manager': {
            css: '//assets.squarespace.com/universal/styles-compressed/website-overlays-manager-a81f4f351e0b41eedf7d-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/website-overlays-manager-81328279e26303ecdcd4-min.en-US.js'
          }
        },
        pageType: 2,
        website: {
          id: '6511a2cb1aa9fb5b4606268a',
          identifier: 'lobster-reed-cf94',
          websiteType: 1,
          contentModifiedOn: 1738856923875,
          cloneable: false,
          hasBeenCloneable: false,
          siteStatus: {},
          language: 'en-US',
          timeZone: 'America/Denver',
          machineTimeZoneOffset: -25200000,
          timeZoneOffset: -25200000,
          timeZoneAbbr: 'MST',
          siteTitle: 'REFORM IS COMING',
          fullSiteTitle: 'Terms of Service \u2014 REFORM IS COMING',
          siteDescription: '',
          location: {},
          shareButtonOptions: { 7: true, 6: true, 8: true, 2: true, 4: true, 1: true, 3: true },
          authenticUrl: 'https://www.thereligionbusiness.com',
          internalUrl: 'https://lobster-reed-cf94.squarespace.com',
          baseUrl: 'https://www.thereligionbusiness.com',
          primaryDomain: 'www.thereligionbusiness.com',
          sslSetting: 3,
          isHstsEnabled: true,
          socialAccounts: [
            {
              serviceId: 64,
              screenname: 'Instagram',
              addedOn: 1695654604169,
              profileUrl: 'https://www.instagram.com/religionbusiness',
              iconEnabled: true,
              serviceName: 'instagram-unauth'
            },
            {
              serviceId: 62,
              screenname: 'Twitter',
              addedOn: 1695657525054,
              profileUrl: 'http://twitter.com/religionbiz',
              iconEnabled: true,
              serviceName: 'twitter-unauth'
            },
            {
              serviceId: 65,
              screenname: 'LinkedIn',
              addedOn: 1735237069087,
              profileUrl: 'https://www.linkedin.com/company/the-religion-business/about/?viewAsMember=true',
              iconEnabled: true,
              serviceName: 'linkedin-unauth'
            }
          ],
          typekitId: '',
          statsMigrated: false,
          imageMetadataProcessingEnabled: false,
          screenshotId: 'd834cebe06094e7feb953401350445fed5b1dc8cf7b27687fe4e3020312cb074',
          captchaSettings: { enabledForDonations: false },
          showOwnerLogin: false
        },
        websiteSettings: {
          id: '6511a2cc1aa9fb5b4606268d',
          websiteId: '6511a2cb1aa9fb5b4606268a',
          subjects: [],
          country: 'US',
          state: 'CO',
          simpleLikingEnabled: true,
          popupOverlaySettings: { style: 1, enabledPages: [] },
          commentLikesAllowed: true,
          commentAnonAllowed: true,
          commentThreaded: true,
          commentApprovalRequired: false,
          commentAvatarsOn: true,
          commentSortType: 2,
          commentFlagThreshold: 0,
          commentFlagsAllowed: true,
          commentEnableByDefault: true,
          commentDisableAfterDaysDefault: 0,
          disqusShortname: '',
          commentsEnabled: false,
          storeSettings: {
            returnPolicy: null,
            termsOfService: null,
            privacyPolicy: null,
            expressCheckout: false,
            continueShoppingLinkUrl: '/',
            useLightCart: false,
            showNoteField: false,
            shippingCountryDefaultValue: 'US',
            billToShippingDefaultValue: false,
            showShippingPhoneNumber: true,
            isShippingPhoneRequired: false,
            showBillingPhoneNumber: true,
            isBillingPhoneRequired: false,
            currenciesSupported: [
              'USD',
              'CAD',
              'GBP',
              'AUD',
              'EUR',
              'CHF',
              'NOK',
              'SEK',
              'DKK',
              'NZD',
              'SGD',
              'MXN',
              'HKD',
              'CZK',
              'ILS',
              'MYR',
              'RUB',
              'PHP',
              'PLN',
              'THB',
              'BRL',
              'ARS',
              'COP',
              'IDR',
              'INR',
              'JPY',
              'ZAR'
            ],
            defaultCurrency: 'USD',
            selectedCurrency: 'USD',
            measurementStandard: 1,
            showCustomCheckoutForm: false,
            checkoutPageMarketingOptInEnabled: true,
            enableMailingListOptInByDefault: false,
            sameAsRetailLocation: false,
            merchandisingSettings: {
              scarcityEnabledOnProductItems: false,
              scarcityEnabledOnProductBlocks: false,
              scarcityMessageType: 'DEFAULT_SCARCITY_MESSAGE',
              scarcityThreshold: 10,
              multipleQuantityAllowedForServices: true,
              restockNotificationsEnabled: false,
              restockNotificationsSuccessText: '',
              restockNotificationsMailingListSignUpEnabled: false,
              relatedProductsEnabled: false,
              relatedProductsOrdering: 'random',
              soldOutVariantsDropdownDisabled: false,
              productComposerOptedIn: false,
              productComposerABTestOptedOut: false,
              productReviewsEnabled: false
            },
            minimumOrderSubtotalEnabled: false,
            minimumOrderSubtotal: { currency: 'USD', value: '0.00' },
            isLive: false,
            multipleQuantityAllowedForServices: true
          },
          useEscapeKeyToLogin: false,
          ssBadgeType: 1,
          ssBadgePosition: 4,
          ssBadgeVisibility: 1,
          ssBadgeDevices: 1,
          pinterestOverlayOptions: { mode: 'disabled' },
          ampEnabled: false,
          userAccountsSettings: { loginAllowed: false, signupAllowed: false }
        },
        cookieSettings: {
          isCookieBannerEnabled: false,
          isRestrictiveCookiePolicyEnabled: false,
          cookieBannerText: '',
          cookieBannerTheme: '',
          cookieBannerVariant: '',
          cookieBannerPosition: '',
          cookieBannerCtaVariant: '',
          cookieBannerCtaText: '',
          cookieBannerAcceptType: 'OPT_IN',
          cookieBannerOptOutCtaText: '',
          cookieBannerHasOptOut: false,
          cookieBannerHasManageCookies: true,
          cookieBannerManageCookiesLabel: '',
          cookieBannerSavedPreferencesText: '',
          cookieBannerSavedPreferencesLayout: 'PILL'
        },
        websiteCloneable: false,
        collection: {
          title: 'Terms of Service',
          id: '6511bdcfd6cde544993bceaf',
          fullUrl: '/terms-of-service',
          type: 10,
          permissionType: 1
        },
        subscribed: false,
        appDomain: 'squarespace.com',
        templateTweakable: true,
        tweakJSON: {
          'form-use-theme-colors': 'false',
          'header-logo-height': '20px',
          'header-mobile-logo-max-height': '30px',
          'header-vert-padding': '1.5vw',
          'header-width': 'Inset',
          maxPageWidth: '1400px',
          pagePadding: '2vw',
          'tweak-blog-alternating-side-by-side-image-aspect-ratio': '1:1 Square',
          'tweak-blog-alternating-side-by-side-image-spacing': '6%',
          'tweak-blog-alternating-side-by-side-meta-spacing': '20px',
          'tweak-blog-alternating-side-by-side-primary-meta': 'Categories',
          'tweak-blog-alternating-side-by-side-read-more-spacing': '20px',
          'tweak-blog-alternating-side-by-side-secondary-meta': 'Date',
          'tweak-blog-basic-grid-columns': '3',
          'tweak-blog-basic-grid-image-aspect-ratio': '1:1 Square',
          'tweak-blog-basic-grid-image-spacing': '30px',
          'tweak-blog-basic-grid-meta-spacing': '17px',
          'tweak-blog-basic-grid-primary-meta': 'Categories',
          'tweak-blog-basic-grid-read-more-spacing': '37px',
          'tweak-blog-basic-grid-secondary-meta': 'Date',
          'tweak-blog-item-custom-width': '75',
          'tweak-blog-item-show-author-profile': 'false',
          'tweak-blog-item-width': 'Narrow',
          'tweak-blog-masonry-columns': '2',
          'tweak-blog-masonry-horizontal-spacing': '64px',
          'tweak-blog-masonry-image-spacing': '20px',
          'tweak-blog-masonry-meta-spacing': '10px',
          'tweak-blog-masonry-primary-meta': 'Categories',
          'tweak-blog-masonry-read-more-spacing': '22px',
          'tweak-blog-masonry-secondary-meta': 'Date',
          'tweak-blog-masonry-vertical-spacing': '231px',
          'tweak-blog-side-by-side-image-aspect-ratio': '1:1 Square',
          'tweak-blog-side-by-side-image-spacing': '6%',
          'tweak-blog-side-by-side-meta-spacing': '20px',
          'tweak-blog-side-by-side-primary-meta': 'Categories',
          'tweak-blog-side-by-side-read-more-spacing': '20px',
          'tweak-blog-side-by-side-secondary-meta': 'Date',
          'tweak-blog-single-column-image-spacing': '50px',
          'tweak-blog-single-column-meta-spacing': '30px',
          'tweak-blog-single-column-primary-meta': 'Categories',
          'tweak-blog-single-column-read-more-spacing': '30px',
          'tweak-blog-single-column-secondary-meta': 'Date',
          'tweak-events-stacked-show-thumbnails': 'true',
          'tweak-events-stacked-thumbnail-size': '3:2 Standard',
          'tweak-fixed-header': 'false',
          'tweak-fixed-header-style': 'Scroll Back',
          'tweak-global-animations-animation-curve': 'ease',
          'tweak-global-animations-animation-delay': '0.6s',
          'tweak-global-animations-animation-duration': '1.50s',
          'tweak-global-animations-animation-style': 'fade',
          'tweak-global-animations-animation-type': 'fade',
          'tweak-global-animations-complexity-level': 'detailed',
          'tweak-global-animations-enabled': 'true',
          'tweak-portfolio-grid-basic-custom-height': '50',
          'tweak-portfolio-grid-overlay-custom-height': '50',
          'tweak-portfolio-hover-follow-acceleration': '10%',
          'tweak-portfolio-hover-follow-animation-duration': 'Fast',
          'tweak-portfolio-hover-follow-animation-type': 'Fade',
          'tweak-portfolio-hover-follow-delimiter': 'Bullet',
          'tweak-portfolio-hover-follow-front': 'false',
          'tweak-portfolio-hover-follow-layout': 'Inline',
          'tweak-portfolio-hover-follow-size': '50',
          'tweak-portfolio-hover-follow-text-spacing-x': '1.5',
          'tweak-portfolio-hover-follow-text-spacing-y': '1.5',
          'tweak-portfolio-hover-static-animation-duration': 'Fast',
          'tweak-portfolio-hover-static-animation-type': 'Fade',
          'tweak-portfolio-hover-static-delimiter': 'Hyphen',
          'tweak-portfolio-hover-static-front': 'true',
          'tweak-portfolio-hover-static-layout': 'Inline',
          'tweak-portfolio-hover-static-size': '50',
          'tweak-portfolio-hover-static-text-spacing-x': '1.5',
          'tweak-portfolio-hover-static-text-spacing-y': '1.5',
          'tweak-portfolio-index-background-animation-duration': 'Medium',
          'tweak-portfolio-index-background-animation-type': 'Fade',
          'tweak-portfolio-index-background-custom-height': '50',
          'tweak-portfolio-index-background-delimiter': 'None',
          'tweak-portfolio-index-background-height': 'Large',
          'tweak-portfolio-index-background-horizontal-alignment': 'Center',
          'tweak-portfolio-index-background-link-format': 'Stacked',
          'tweak-portfolio-index-background-persist': 'false',
          'tweak-portfolio-index-background-vertical-alignment': 'Middle',
          'tweak-portfolio-index-background-width': 'Full',
          'tweak-product-basic-item-click-action': 'None',
          'tweak-product-basic-item-gallery-aspect-ratio': '1:1 Square',
          'tweak-product-basic-item-gallery-design': 'Slideshow',
          'tweak-product-basic-item-gallery-width': '53%',
          'tweak-product-basic-item-hover-action': 'Zoom',
          'tweak-product-basic-item-image-spacing': '10vw',
          'tweak-product-basic-item-image-zoom-factor': '1.5',
          'tweak-product-basic-item-product-variant-display': 'Dropdown',
          'tweak-product-basic-item-thumbnail-placement': 'Side',
          'tweak-product-basic-item-variant-picker-layout': 'Dropdowns',
          'tweak-products-add-to-cart-button': 'false',
          'tweak-products-columns': '2',
          'tweak-products-gutter-column': '2vw',
          'tweak-products-gutter-row': '4vw',
          'tweak-products-header-text-alignment': 'Middle',
          'tweak-products-image-aspect-ratio': '1:1 Square',
          'tweak-products-image-text-spacing': '2vw',
          'tweak-products-mobile-columns': '1',
          'tweak-products-text-alignment': 'Middle',
          'tweak-products-width': 'Inset',
          'tweak-transparent-header': 'false'
        },
        templateId: '5c5a519771c10ba3470d8101',
        templateVersion: '7.1',
        pageFeatures: [1, 2, 4],
        gmRenderKey: 'QUl6YVN5Q0JUUk9xNkx1dkZfSUUxcjQ2LVQ0QWVUU1YtMGQ3bXk4',
        templateScriptsRootUrl: 'https://static1.squarespace.com/static/vta/5c5a519771c10ba3470d8101/scripts/',
        impersonatedSession: false,
        tzData: {
          zones: [[-420, 'US', 'M%sT', null]],
          rules: {
            US: [
              [1967, 2006, null, 'Oct', 'lastSun', '2:00', '0', 'S'],
              [1987, 2006, null, 'Apr', 'Sun>=1', '2:00', '1:00', 'D'],
              [2007, 'max', null, 'Mar', 'Sun>=8', '2:00', '1:00', 'D'],
              [2007, 'max', null, 'Nov', 'Sun>=1', '2:00', '0', 'S']
            ]
          }
        },
        showAnnouncementBar: false,
        recaptchaEnterpriseContext: { recaptchaEnterpriseSiteKey: '6LdDFQwjAAAAAPigEvvPgEVbb7QBm-TkVJdDTlAv' },
        i18nContext: { timeZoneData: { id: 'America/Denver', name: 'Mountain Time' } },
        env: 'PRODUCTION'
      };
    </script>
    <script type="application/ld+json">
      {
        "url": "https://www.thereligionbusiness.com",
        "name": "REFORM IS COMING",
        "description": "",
        "@context": "http://schema.org",
        "@type": "WebSite"
      }
    </script>
    <script type="application/ld+json">
      { "address": "", "@context": "http://schema.org", "@type": "LocalBusiness" }
    </script>
    <link
      rel="stylesheet"
      type="text/css"
      href="https://static1.squarespace.com/static/versioned-site-css/6511a2cb1aa9fb5b4606268a/28/5c5a519771c10ba3470d8101/6511a2cc1aa9fb5b46062692/1612/site.css" />
    <script>
      Static.COOKIE_BANNER_CAPABLE = true;
    </script>
    <!-- End of Squarespace Headers -->
    <link
      rel="stylesheet"
      type="text/css"
      href="https://static1.squarespace.com/static/vta/5c5a519771c10ba3470d8101/versioned-assets/1739381320286-8FJE7NMLDZWANM5PXDLU/static.css" />
  </head>

  <body
    id="collection-6511bdcfd6cde544993bceaf"
    class="tweak-products-width-inset tweak-products-image-aspect-ratio-11-square tweak-products-text-alignment-middle tweak-products-price-show tweak-products-nested-category-type-top tweak-products-header-text-alignment-middle tweak-products-breadcrumbs tweak-portfolio-grid-overlay-width-full tweak-portfolio-grid-overlay-height-large tweak-portfolio-grid-overlay-image-aspect-ratio-11-square tweak-portfolio-grid-overlay-text-placement-center tweak-portfolio-grid-overlay-show-text-after-hover image-block-poster-text-alignment-center image-block-card-content-position-center image-block-card-text-alignment-left image-block-overlap-content-position-center image-block-overlap-text-alignment-left image-block-collage-content-position-center image-block-collage-text-alignment-center image-block-stack-text-alignment-left tweak-blog-single-column-width-inset tweak-blog-single-column-text-alignment-center tweak-blog-single-column-image-placement-above tweak-blog-single-column-delimiter-bullet tweak-blog-single-column-read-more-style-show tweak-blog-single-column-primary-meta-categories tweak-blog-single-column-secondary-meta-date tweak-blog-single-column-meta-position-top tweak-blog-single-column-content-full-post tweak-blog-item-width-narrow tweak-blog-item-text-alignment-left tweak-blog-item-meta-position-above-title tweak-blog-item-show-date tweak-blog-item-delimiter-bullet primary-button-style-solid primary-button-shape-pill secondary-button-style-outline secondary-button-shape-pill tertiary-button-style-outline tertiary-button-shape-pill tweak-events-stacked-width-full tweak-events-stacked-height-large tweak-events-stacked-show-thumbnails tweak-events-stacked-thumbnail-size-32-standard tweak-events-stacked-date-style-with-text tweak-events-stacked-show-time tweak-events-stacked-show-location tweak-events-stacked-show-excerpt tweak-blog-basic-grid-width-full tweak-blog-basic-grid-image-aspect-ratio-11-square tweak-blog-basic-grid-text-alignment-left tweak-blog-basic-grid-delimiter-bullet tweak-blog-basic-grid-image-placement-above tweak-blog-basic-grid-read-more-style-hide tweak-blog-basic-grid-primary-meta-categories tweak-blog-basic-grid-secondary-meta-date tweak-blog-basic-grid-excerpt-hide header-overlay-alignment-center tweak-portfolio-index-background-link-format-stacked tweak-portfolio-index-background-width-full tweak-portfolio-index-background-height-large tweak-portfolio-index-background-vertical-alignment-middle tweak-portfolio-index-background-horizontal-alignment-center tweak-portfolio-index-background-delimiter-none tweak-portfolio-index-background-animation-type-fade tweak-portfolio-index-background-animation-duration-medium tweak-portfolio-hover-follow-layout-inline tweak-portfolio-hover-follow-delimiter-bullet tweak-portfolio-hover-follow-animation-type-fade tweak-portfolio-hover-follow-animation-duration-fast tweak-portfolio-hover-static-layout-inline tweak-portfolio-hover-static-front tweak-portfolio-hover-static-delimiter-hyphen tweak-portfolio-hover-static-animation-type-fade tweak-portfolio-hover-static-animation-duration-fast form-field-style-solid form-field-shape-square form-field-border-all form-field-checkbox-type-icon form-field-checkbox-fill-solid form-field-checkbox-color-inverted form-field-checkbox-shape-square form-field-checkbox-layout-stack form-field-radio-type-icon form-field-radio-fill-solid form-field-radio-color-normal form-field-radio-shape-pill form-field-radio-layout-stack form-field-survey-fill-solid form-field-survey-color-normal form-field-survey-shape-pill form-field-hover-focus-outline form-submit-button-style-label tweak-blog-alternating-side-by-side-width-full tweak-blog-alternating-side-by-side-image-aspect-ratio-11-square tweak-blog-alternating-side-by-side-text-alignment-left tweak-blog-alternating-side-by-side-read-more-style-hide tweak-blog-alternating-side-by-side-image-text-alignment-middle tweak-blog-alternating-side-by-side-delimiter-bullet tweak-blog-alternating-side-by-side-meta-position-top tweak-blog-alternating-side-by-side-primary-meta-categories tweak-blog-alternating-side-by-side-secondary-meta-date tweak-blog-alternating-side-by-side-excerpt-show tweak-global-animations-enabled tweak-global-animations-complexity-level-detailed tweak-global-animations-animation-style-fade tweak-global-animations-animation-type-fade tweak-global-animations-animation-curve-ease tweak-blog-masonry-width-inset tweak-blog-masonry-text-alignment-center tweak-blog-masonry-primary-meta-categories tweak-blog-masonry-secondary-meta-date tweak-blog-masonry-meta-position-top tweak-blog-masonry-read-more-style-hide tweak-blog-masonry-delimiter-space tweak-blog-masonry-image-placement-above tweak-blog-masonry-excerpt-show tweak-product-basic-item-product-variant-display-dropdown tweak-product-basic-item-product-subscription-display-radio tweak-product-basic-item-product-subscription-border-shape-square tweak-product-basic-item-width-full tweak-product-basic-item-gallery-aspect-ratio-11-square tweak-product-basic-item-text-alignment-left tweak-product-basic-item-navigation-none tweak-product-basic-item-description-position-below-price tweak-product-basic-item-description-position-mobile-below-add-to-cart-button tweak-product-basic-item-content-alignment-top tweak-product-basic-item-gallery-design-slideshow tweak-product-basic-item-gallery-placement-right tweak-product-basic-item-thumbnail-placement-side tweak-product-basic-item-click-action-none tweak-product-basic-item-hover-action-zoom tweak-product-basic-item-variant-picker-layout-dropdowns tweak-product-basic-item-add-to-cart-standalone tweak-product-basic-item-add-to-cart-mobile-standalone header-width-inset tweak-fixed-header-style-scroll-back tweak-blog-side-by-side-width-inset tweak-blog-side-by-side-image-placement-left tweak-blog-side-by-side-image-aspect-ratio-11-square tweak-blog-side-by-side-primary-meta-categories tweak-blog-side-by-side-secondary-meta-date tweak-blog-side-by-side-meta-position-top tweak-blog-side-by-side-text-alignment-left tweak-blog-side-by-side-image-text-alignment-middle tweak-blog-side-by-side-read-more-style-show tweak-blog-side-by-side-delimiter-bullet tweak-blog-side-by-side-excerpt-show tweak-portfolio-grid-basic-width-full tweak-portfolio-grid-basic-height-small tweak-portfolio-grid-basic-image-aspect-ratio-11-square tweak-portfolio-grid-basic-text-alignment-left tweak-portfolio-grid-basic-hover-effect-fade hide-opentable-icons opentable-style-dark tweak-product-quick-view-button-style-floating tweak-product-quick-view-button-position-center tweak-product-quick-view-lightbox-excerpt-display-truncate tweak-product-quick-view-lightbox-show-arrows tweak-product-quick-view-lightbox-show-close-button tweak-product-quick-view-lightbox-controls-weight-light native-currency-code-usd collection-type-page collection-6511bdcfd6cde544993bceaf collection-layout-default mobile-style-available sqs-seven-one"
    tabindex="-1">
    <div id="siteWrapper" class="clearfix site-wrapper">
      <div id="floatingCart" class="floating-cart hidden">
        <a href="/cart" class="icon icon--stroke icon--fill icon--cart sqs-custom-cart">
          <span class="Cart-inner">
            <svg class="icon icon--cart" viewBox="0 0 31 24">
              <g class="svg-icon cart-icon--odd">
                <circle fill="none" stroke-miterlimit="10" cx="22.5" cy="21.5" r="1" />
                <circle fill="none" stroke-miterlimit="10" cx="9.5" cy="21.5" r="1" />
                <path
                  fill="none"
                  stroke-miterlimit="10"
                  d="M0,1.5h5c0.6,0,1.1,0.4,1.1,1l1.7,13
      c0.1,0.5,0.6,1,1.1,1h15c0.5,0,1.2-0.4,1.4-0.9l3.3-8.1c0.2-0.5-0.1-0.9-0.6-0.9H12" />
              </g>
            </svg>

            <div class="legacy-cart icon-cart-quantity">
              <span class="sqs-cart-quantity">0</span>
            </div>
          </span>
        </a>
      </div>
      <main id="page" class="container" role="main">
        <article class="sections" id="sections" data-page-sections="6511bdcfd6cde544993bceb0">
          <section
            data-test="page-section"
            data-section-theme=""
            class="page-section full-bleed-section layout-engine-section background-width--full-bleed section-height--custom content-width--wide horizontal-alignment--center vertical-alignment--middle"
            data-section-id="6511bde3faed306222d87757"
            data-controller="SectionWrapperController"
            data-current-styles='{
"imageOverlayOpacity": 0.15,
"backgroundWidth": "background-width--full-bleed",
"sectionHeight": "section-height--custom",
"customSectionHeight": 1,
"horizontalAlignment": "horizontal-alignment--center",
"verticalAlignment": "vertical-alignment--middle",
"contentWidth": "content-width--wide",
"customContentWidth": 50,
"sectionTheme": "",
"sectionAnimation": "none",
"backgroundMode": "image"
}'
            data-current-context='{
"video": {
"playbackSpeed": 0.5,
"filter": 1,
"filterStrength": 0,
"zoom": 0,
"videoSourceProvider": "none"
},
"backgroundImageId": null,
"backgroundMediaEffect": {
"type": "none"
},
"divider": {
"enabled": false
},
"typeName": "page"
}'
            data-animation="none"
            data-fluid-engine-section
            style="min-height: 1vh">
            <div class="section-border">
              <div class="section-background"></div>
            </div>
            <div class="content-wrapper" style="padding-top: calc(1vmax / 10); padding-bottom: calc(1vmax / 10)">
              <div class="content">
                <div data-fluid-engine="true">
                  <style>
                    .fe-6511bde3faed306222d87756 {
                      --grid-gutter: calc(var(--sqs-mobile-site-gutter, 6vw) - 11px);
                      --cell-max-width: calc((var(--sqs-site-max-width, 1500px) - (11px * (8 - 1))) / 8);

                      display: grid;
                      position: relative;
                      grid-area: 1/1/-1/-1;
                      grid-template-rows: repeat(31, minmax(24px, auto));
                      grid-template-columns:
                        minmax(var(--grid-gutter), 1fr)
                        repeat(8, minmax(0, var(--cell-max-width)))
                        minmax(var(--grid-gutter), 1fr);
                      row-gap: 11px;
                      column-gap: 11px;
                    }

                    @media (min-width: 768px) {
                      .background-width--inset .fe-6511bde3faed306222d87756 {
                        --inset-padding: calc(var(--sqs-site-gutter) * 2);
                      }

                      .fe-6511bde3faed306222d87756 {
                        --grid-gutter: calc(var(--sqs-site-gutter, 4vw) - 11px);
                        --cell-max-width: calc((var(--sqs-site-max-width, 1500px) - (11px * (24 - 1))) / 24);
                        --inset-padding: 0vw;

                        --row-height-scaling-factor: 0.0215;
                        --container-width: min(
                          var(--sqs-site-max-width, 1500px),
                          calc(100vw - var(--sqs-site-gutter, 4vw) * 2 - var(--inset-padding))
                        );

                        grid-template-rows: repeat(
                          163,
                          minmax(calc(var(--container-width) * var(--row-height-scaling-factor)), auto)
                        );
                        grid-template-columns:
                          minmax(var(--grid-gutter), 1fr)
                          repeat(24, minmax(0, var(--cell-max-width)))
                          minmax(var(--grid-gutter), 1fr);
                      }
                    }

                    .fe-block-9725a8261870f0716192 {
                      grid-area: 1/2/32/10;
                      z-index: 1;

                      @media (max-width: 767px) {
                      }
                    }

                    .fe-block-9725a8261870f0716192 .sqs-block {
                      justify-content: flex-start;
                    }

                    .fe-block-9725a8261870f0716192 .sqs-block-alignment-wrapper {
                      align-items: flex-start;
                    }

                    @media (min-width: 768px) {
                      .fe-block-9725a8261870f0716192 {
                        grid-area: 2/5/164/23;
                        z-index: 1;
                      }

                      .fe-block-9725a8261870f0716192 .sqs-block {
                        justify-content: flex-start;
                      }

                      .fe-block-9725a8261870f0716192 .sqs-block-alignment-wrapper {
                        align-items: flex-start;
                      }
                    }
                  </style>
                  <div class="fluid-engine fe-6511bde3faed306222d87756">
                    <div class="fe-block fe-block-9725a8261870f0716192">
                      <div
                        class="sqs-block html-block sqs-block-html"
                        data-blend-mode="NORMAL"
                        data-block-type="2"
                        data-border-radii='&#123;"topLeft":&#123;"unit":"px","value":0.0&#125;,"topRight":&#123;"unit":"px","value":0.0&#125;,"bottomLeft":&#123;"unit":"px","value":0.0&#125;,"bottomRight":&#123;"unit":"px","value":0.0&#125;&#125;'
                        id="block-9725a8261870f0716192">
                        <div class="sqs-block-content">
                          <div class="sqs-html-content">
                            <p class="" style="white-space: pre-wrap"><strong>TGC Website Terms of Use</strong></p>
                            <p style="text-align: center; white-space: pre-wrap" class="">
                              Last Updated: December 1, 2024
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>1.&nbsp;Acceptance of Terms</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              These Website Terms of Use (these “<strong>Terms</strong>”) govern your access to websites
                              and related services operated by or on behalf of TGC NOW, LLC and its subsidiaries
                              (“<strong>TGC</strong>” “<strong>we</strong>” or “<strong>us</strong>”). These Terms are
                              important and affect your legal rights, so please read them carefully. Note that Section
                              14 of these Terms contains a mandatory arbitration provision that requires the use of
                              arbitration on an individual basis and limits the remedies available to you in the event
                              of certain disputes.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              By accessing or using&nbsp;www.brokenshepherds.com<strong> </strong>and our various related
                              websites and services (collectively, the “<strong>TGC Services</strong>”), you agree to be
                              bound by these Terms and all of the terms incorporated herein by reference.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You must be 18 years of age or older and reside in the United States or any of its
                              territories to use the TGC Services. By accepting these Terms, you represent that you have
                              the legal authority to do so, and that, if you have accepted these Terms on behalf of any
                              person or entity, you represent that you have legal authority to do so and that such
                              person or entity agrees to be responsible to us if you or such person or entity violates
                              these Terms. If you do not agree to every provision of these Terms, you may not, and we do
                              not authorize you to, access or use the TGC Services or any features provided therein.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              By accessing or using the TGC Services, you represent and warrant that you have not been
                              previously suspended or removed from the TGC Services or engaged in any activity that
                              could result in suspension or removal from the TGC Services.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You should not construe&nbsp;TGC’s&nbsp;publication of any content found on the TGC
                              Services as an endorsement by&nbsp;TGC&nbsp;of the views expressed therein, or any
                              warranty or guarantee of any strategy, recommendation, treatment, action, or application
                              of medication or preparation made by the author of such content.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We may revise these Terms at any time for any reason and may provide you notice of these
                              changes by any reasonable means, including through the TGC Services. You can determine
                              when we last updated these Terms by referring to the “Last Updated” legend at the top of
                              these Terms. Except to the extent that your express consent to any revised Terms is
                              required under applicable law, by continuing to access, browse or use the TGC Services,
                              you agree to any revised Terms. If you do not agree to any revised Terms, you may not and
                              we do not authorize you to use the TGC Services. We strongly recommend that you
                              periodically visit this page to review these Terms.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>2.&nbsp;User Registration </strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              In order to access and use certain areas or features of the TGC Services, you may need to
                              provide certain information and/or answer certain questions. Each registration is for a
                              single user only.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You agree to (a) provide accurate, current and complete information, (b) maintain and
                              promptly update, as necessary, your information, (c) be responsible for the acts or
                              omissions of any third party who has authority to access or use the TGC Services on your
                              behalf, and (d) immediately notify us if you discover or otherwise suspect any security
                              breaches related to the TGC Services. If you provide information that is untrue,
                              inaccurate, not current or incomplete, we may suspend and/or terminate your current or
                              future use of the TGC Services.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              By providing information and/or answering questions, you also consent to receive
                              electronic communications from&nbsp;TGC&nbsp;(e.g., via email or by posting notices to the
                              TGC Services). You should maintain copies of electronic communications from us by printing
                              a paper copy or saving an electronic copy.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We may also send you promotional communications via email, including, but not limited to,
                              newsletters, special offers, surveys and other news and information we think will be of
                              interest to you. You may opt out of receiving these promotional emails at any time by
                              following the unsubscribe instructions provided therein.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>3.&nbsp;Right to Access and Use the TGC Services and Content</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              Unless otherwise indicated in writing by us, the TGC Services and all content and other
                              materials contained therein, including, without limitation, any&nbsp;TGC&nbsp;service mark
                              or logo and all designs, text, graphics, pictures, information, data, software, other
                              files and the selection and arrangement thereof (collectively, “<strong>Content</strong>”)
                              are the property of&nbsp;TGC&nbsp;or our licensors or users, as applicable, and are
                              protected by U.S. and international copyright and other laws.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Subject to these Terms, you are hereby granted a limited personal, revocable,
                              non-exclusive, non-transferable, non-sublicensable right to access, view and make
                              personal, non-commercial use of the TGC Services and Content solely in connection with the
                              BROKEN SHEPHERD™ platform&nbsp; to track, monitor and measure donors and donations,
                              volunteers, revenue allocations and expenses, assets and liabilities, fundraising and the
                              provision and receipt of non-profit services, and to facilitate the processing of
                              donations, and not for any other purpose. All rights not expressly granted herein are
                              reserved. You do not acquire any ownership interest in the TGC Services or Content under
                              these Terms, or any other rights thereto other than to use the TGC Services in accordance
                              with the rights granted by, and subject to all terms, conditions and restrictions of these
                              Terms.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You do not have any right to, and you shall not, directly or indirectly: (a) sell, resell
                              or use commercially the TGC Services or Content, (b) distribute, publicly perform or
                              publicly display the TGC Services or any Content, (c) modify or otherwise make any
                              derivative uses of the TGC Services or Content, or any portion thereof, (d) use any data
                              mining, robots or similar data gathering or extraction methods, (e) download (other than
                              page caching) any portion of the TGC Services or Content, except as expressly permitted by
                              us, (f) use the TGC Services to stalk, threaten, or otherwise violate the rights of
                              others, including without limitation others’ privacy rights or rights of publicity; (g)
                              interfere with the TGC Services or servers or networks used in connection with the TGC
                              Services; or (h) use the TGC Services or Content other than for their intended purposes.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Any use of the TGC Services or Content other than as specifically authorized herein,
                              without our prior written permission, is strictly prohibited and will terminate the right
                              of access and use granted herein. Such unauthorized use may also violate applicable laws,
                              including, without limitation, copyright and trademark laws and applicable communications
                              regulations and statutes. Except as expressly permitted herein, nothing in these Terms
                              shall be construed as conferring any right or license to any patent, trademark, copyright
                              or other proprietary rights of&nbsp;TGC&nbsp;or any third party, whether by estoppel,
                              implication or otherwise.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You will not remove, alter or conceal any copyright, trademark, service mark or other
                              proprietary rights notices incorporated in or accompanying any Content and you will not
                              reproduce, modify, adapt, prepare derivative works based on, perform, display, publish,
                              distribute, transmit, broadcast, sell, license or otherwise exploit any Content.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We reserve the right in our sole discretion to modify, suspend or discontinue, temporarily
                              or permanently, the TGC Services (or any features or parts thereof) at any time.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>4.&nbsp;Trademarks</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              The&nbsp;BROKEN SHEPHERD™ mark,&nbsp;logo, and any other&nbsp;TGC&nbsp;product or service
                              names, trademarks, taglines, logos, or other indicia that may appear on the TGC Services
                              (“<strong>Marks</strong>”) are the property of&nbsp;TGC&nbsp;or its subsidiaries,
                              affiliates or third parties, and may not be copied, imitated or used, in whole or in part,
                              without our prior written permission. Nothing contained in these Terms and/or the TGC
                              Services shall be construed as granting, by implication or otherwise, any license or right
                              to use any such Marks without the prior written permission of&nbsp;TGC&nbsp;or such third
                              party that may own such Marks.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>5.&nbsp;Legal Requirements; Privacy Policy</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Our Privacy Policy describes how we handle the personal information you provide to us when
                              you use the TGC Services. For an explanation of our privacy practices, please visit our
                              Privacy Policy located at <a href="/privacyPolicy">/privacyPolicy</a>.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>6.&nbsp;User Content</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You are solely responsible and liable for all data, information and other materials
                              (“<strong>User Content</strong>”) that you submit, upload, post, e-mail or otherwise
                              transmit (“<strong>Transmit</strong>”) in connection with the TGC Services. In addition,
                              we have no control over, and shall have no liability for, any damages resulting from the
                              use (including without limitation, republication) or misuse by any third party of
                              information made public through the TGC Services. IF YOU CHOOSE TO SUBMIT TO US, OR
                              OTHERWISE MAKE ANY USER CONTENT PUBLICLY AVAILABLE, YOU DO SO AT YOUR OWN RISK AND WE
                              SHALL HAVE NO LIABILITY THEREFOR.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You agree that you will not, and will not permit anyone else to, directly or indirectly:
                              (a) Transmit any User Content that is unlawful, harmful, threatening, abusive, hateful,
                              obscene, harassing, tortious, defamatory, libelous, slanderous, pornographic, profane,
                              vulgar, offensive, lewd, invasive of another’s privacy or racially, ethnically or
                              otherwise objectionable; (b) Transmit any User Content: (i) that you do not have the right
                              to Transmit, under any law or contractual or fiduciary relationships, including, without
                              limitation, any inside information or proprietary or confidential information; (ii) that
                              infringes any patent, copyright, trademark or other intellectual property right or
                              misappropriates any trade secret or right of privacy of any third-party; (iii) that
                              constitutes unsolicited or unauthorized advertising or promotional materials, “spam,”
                              “chain letters,” or pyramid schemes; or (iv) that contains any software routine, code,
                              instruction or virus that is designed to disable, delete, modify, damage or erase
                              software, hardware or data; or (c) forge headers or otherwise manipulate identifiers in
                              order to disguise any User Content Transmitted through the TGC Services.<br />
                              <br />
                              Although we have no obligation to screen, edit or monitor User Content, we reserve the
                              right, and have absolute discretion, to remove, screen or edit User Content posted or
                              stored on the TGC Services at any time and for any reason, and you are solely responsible
                              for creating backup copies of and replacing any User Content you post or store on the TGC
                              Services at your sole cost and expense.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>7.&nbsp;Rights in User Content</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We do not claim any ownership interest in User Content. However, by uploading, posting or
                              submitting User Content to the TGC Services or to our pages or feeds on third-party social
                              media platforms (e.g.,&nbsp;TGC’s&nbsp;Facebook page, LinkedIn page or X formerly Twitter
                              feed), you hereby grant&nbsp;TGC&nbsp;a nonexclusive, royalty-free, worldwide, perpetual,
                              irrevocable and fully sublicensable right and license to use, reproduce, modify, adapt,
                              publish, translate, create derivative works from, distribute, perform and publicly display
                              your User Content, in whole or in part, in any manner or media and for any purpose
                              whatsoever at our sole discretion, including, without limitation, for publicity,
                              promotional, advertising, trade, business, illustration, artistic and other commercial and
                              noncommercial purposes. However,&nbsp;TGC&nbsp;will only share personal information that
                              you provide in accordance with our Privacy Policy.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You agree that&nbsp;TGC&nbsp;may disclose or use any User Content for any purposes
                              permitted under applicable law, including, but not limited to: (a) enforcing these Terms;
                              (b) complying with any laws, regulations or rules of any federal, state or local
                              government or agency; (c) responding to claims that any User Content violates the rights
                              of third parties; or (d) protecting the rights or property of&nbsp;TGC, its customers or
                              the public.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>8.&nbsp;Feedback</strong><br />
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Separate and apart from User Content, you can submit questions, comments, suggestions,
                              ideas, original or creative materials or other information about&nbsp;TGC, or the TGC
                              Services (collectively, “<strong>Feedback</strong>”). Feedback shall become the sole
                              property of&nbsp;TGC.&nbsp;TGC&nbsp;shall own exclusive rights, including, without
                              limitation, all intellectual property rights, in and to Feedback and shall be entitled to
                              the unrestricted use and dissemination of Feedback for any purpose, commercial or
                              otherwise, without acknowledgment or compensation to you.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>9.&nbsp;Third-Party Sites</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We have not reviewed all of the websites linked to the TGC Services and are not
                              responsible for the content of any third-party pages, any other websites linked to the TGC
                              Services, or any products or services offered by third parties. Nothing in the TGC
                              Services, including, without limitation, any links to other websites, should be construed
                              as an endorsement by TGC of any products, services or information of any other persons or
                              companies. Your choice to access a link to any other website is at your own risk, and you
                              agree to comply with all terms and conditions relating to such
                              websites.&nbsp;TGC&nbsp;reserves the right not to link, or to remove the link, to a
                              particular website at any time.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Any links to third-party websites are provided as a convenience to you and are neither
                              owned nor operated by&nbsp;TGC. We have no control over these linked websites and make no
                              representations or warranties with respect to these linked websites or third-party
                              products or services. Your viewing and use of any third-party websites is at your sole
                              discretion and risk.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>10.&nbsp;Indemnification</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              You shall indemnify, hold harmless, and, at&nbsp;TGC’s&nbsp;option,
                              defend&nbsp;TGC&nbsp;and its affiliates and subsidiaries from and against any and all
                              losses, damages, liabilities, costs (including reasonable attorneys’ fees) (“Losses”)
                              incurred by&nbsp;TGC&nbsp;resulting from any third-party claim, suit, action or proceeding
                              relating to or arising from your use of the TGC Services, any User Content, any Feedback
                              you provide, any violation of these Terms by you, or any other act or omission by you,
                              including your violation of any rights of another, arising from your use of the TGC
                              Services or any of its features. You further agree that&nbsp;TGC&nbsp;shall have control
                              of the defense or settlement of any third-party claims unless&nbsp;TGC&nbsp;exercises its
                              option to require you to defend&nbsp;TGC. This indemnity is in addition to, and not in
                              lieu of, any other indemnities set forth in a written agreement between you and&nbsp;TGC.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>11.&nbsp;General Disclaimers</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              THE TGC SERVICES AND THE CONTENT ARE PROVIDED ON AN “AS IS”, “AS AVAILABLE” AND “WITH ALL
                              FAULTS” BASIS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, TGC&nbsp;DOES NOT MAKE ANY
                              REPRESENTATIONS OR WARRANTIES OR ENDORSEMENTS OF ANY KIND WHATSOEVER, EXPRESS OR IMPLIED,
                              AS TO: (A) THE TGC SERVICES; (B) CONTENT; (C) USER CONTENT; OR (D) SECURITY ASSOCIATED
                              WITH THE TRANSMISSION OF INFORMATION TO OR FROM THE TGC SERVICES. TGC HEREBY DISCLAIMS ALL
                              WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF
                              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, THAT ANY RESULTS WILL BE ACHIEVED,
                              NON-INFRINGEMENT, TITLE, CUSTOM, TRADE, QUIET ENJOYMENT, SYSTEM INTEGRATION AND FREEDOM
                              FROM COMPUTER VIRUS.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              TGC&nbsp;DOES NOT REPRESENT OR WARRANT THAT THE TGC SERVICES WILL BE ERROR-FREE OR
                              UNINTERRUPTED; THAT DEFECTS WILL BE CORRECTED; OR THAT THE TGC SERVICES OR THE SERVERS
                              THAT MAKE THE TGC SERVICES AVAILABLE ARE FREE FROM ANY HARMFUL COMPONENTS, INCLUDING,
                              WITHOUT LIMITATION, VIRUSES. TGC DOES NOT MAKE ANY REPRESENTATIONS OR WARRANTIES THAT THE
                              INFORMATION (INCLUDING ANY INSTRUCTIONS) ON THE TGC SERVICES IS ACCURATE, COMPLETE, OR
                              USEFUL. YOU ACKNOWLEDGE THAT YOUR USE OF THE TGC SERVICES IS AT YOUR SOLE RISK. TGC DOES
                              NOT WARRANT THAT YOUR USE OF THE TGC SERVICES IS LAWFUL IN ANY PARTICULAR JURISDICTION.
                              TGC&nbsp;SPECIFICALLY DISCLAIMS ALL SUCH WARRANTIES. SOME JURISDICTIONS LIMIT OR DO NOT
                              ALLOW THE DISCLAIMER OF IMPLIED OR OTHER WARRANTIES SO THE ABOVE DISCLAIMER MAY NOT APPLY
                              TO YOU TO THE EXTENT SUCH JURISDICTION’S LAW IS APPLICABLE TO YOU AND THESE TERMS.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              BY ACCESSING OR USING THE TGC SERVICES YOU REPRESENT AND WARRANT THAT YOUR ACTIVITIES ARE
                              LAWFUL IN EVERY JURISDICTION WHERE YOU ACCESS OR USE THE TGC SERVICES.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>13.&nbsp;Limitation of Liability; Waiver</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL&nbsp;TGC&nbsp;BE LIABLE FOR ANY
                              INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY KIND (INCLUDING, BUT NOT
                              LIMITED TO, LOSS OF REVENUE, INCOME OR PROFITS, LOSS OF USE OR DATA, LOSS OR DIMINUTION IN
                              VALUE OF ASSETS OR SECURITIES, OR DAMAGES FOR BUSINESS INTERRUPTION) ARISING OUT OF OR IN
                              ANY WAY RELATED TO THE ACCESS TO OR USE OF THE TGC SERVICES (INCLUDING, BUT NOT LIMITED
                              TO, USER CONTENT AND LINKS TO THIRD-PARTY WEBSITES), OR THE ORDER, RECEIPT OR USE OF ANY
                              PRODUCT OR SERVICE, OR OTHERWISE RELATED TO THESE TERMS (INCLUDING, BUT NOT LIMITED TO,
                              ANY DAMAGES CAUSED BY OR RESULTING FROM RELIANCE ON ANY INFORMATION OBTAINED
                              FROM&nbsp;TGC, OR FROM EVENTS BEYOND&nbsp;TGC’S&nbsp;REASONABLE CONTROL, REGARDLESS OF THE
                              FORM OF ACTION, WHETHER BASED IN CONTRACT, TORT (INCLUDING, BUT NOT LIMITED TO, SIMPLE
                              NEGLIGENCE, WHETHER ACTIVE, PASSIVE OR IMPUTED) OR ANY OTHER LEGAL OR EQUITABLE THEORY,
                              EVEN IF TGC HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND REGARDLESS OF WHETHER
                              SUCH DAMAGES WERE FORESEEABLE).
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE MAXIMUM AGGREGATE
                              LIABILITY OF&nbsp;TGC&nbsp;ARISING OUT OF OR IN ANY WAY RELATED TO THE TGC SERVICES EXCEED
                              ONE HUNDRED DOLLARS ($100). THE FOREGOING LIMITATIONS SHALL APPLY EVEN IN THE EVENT YOUR
                              REMEDIES HEREUNDER FAIL OF THEIR ESSENTIAL PURPOSE, AND THE FOREGOING SHALL
                              CONSTITUTE&nbsp;TGC’S&nbsp;SOLE LIABILITY AND OBLIGATION IN RESPECT HEREOF.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              IF YOU ARE A CALIFORNIA RESIDENT, YOU HEREBY WAIVE YOUR RIGHTS UNDER CALIFORNIA CIVIL CODE
                              1542, WHICH STATES “A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS THAT THE CREDITOR OR
                              RELEASING PARTY DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF
                              EXECUTING THE RELEASE AND THAT, IF KNOWN BY HIM OR HER, WOULD HAVE MATERIALLY AFFECTED HIS
                              OR HER SETTLEMENT WITH THE DEBTOR OR RELEASED PARTY.”
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>14.&nbsp;Arbitration</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              PLEASE READ THE FOLLOWING SECTION CAREFULLY BECAUSE IT REQUIRES YOU TO ARBITRATE CERTAIN
                              DISPUTES AND CLAIMS WITH&nbsp;TGC&nbsp;AND LIMITS THE MANNER IN WHICH YOU CAN SEEK RELIEF
                              FROM US.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              YOU AND&nbsp;TGC&nbsp;AGREE THAT ANY DISPUTE, CLAIM OR CONTROVERSY ARISING OUT OF OR
                              RELATING IN ANY WAY TO THESE TERMS OR THE TGC SERVICES SHALL BE FINALLY DECIDED BY BINDING
                              ARBITRATION UNDER THE RULES OF THE AMERICAN ARBITRATION ASSOCIATION GOVERNING CONSUMER
                              DISPUTES.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Arbitration uses a single, neutral arbitrator to decide a dispute (instead of a judge or
                              jury); arbitration allows for more limited discovery than in a court case; and the
                              arbitration process and result is subject to very limited review by courts. In an
                              arbitration you have the right, at your expense, to be represented by an attorney of your
                              choosing. Arbitrators can award the same damages and relief under these Terms that a court
                              can award under these Terms. You and&nbsp;TGC&nbsp;agree that any in-person arbitral
                              hearing would occur in the United States in the same county and state as your billing
                              address.&nbsp;TGC&nbsp;further agrees that your filing fee for an arbitration will be
                              capped at the amount set by the American Arbitration Association. You agree that, by
                              agreeing to these Terms, the U.S. Federal Arbitration Act governs the interpretation and
                              enforcement of this provision, and that you and&nbsp;TGC&nbsp;are each waiving the right
                              to a trial by jury and/or to participate in a class action. This arbitration provision
                              shall survive termination of these Terms and the termination of your use of the TGC
                              Services. Further, unless both you and&nbsp;TGC&nbsp;agree otherwise, the arbitrator may
                              not join or consolidate more than one person’s claims with your claims and may not
                              otherwise preside over any form of a representative or class proceeding. If this specific
                              provision is found to be unenforceable, then the entirety of this arbitration provision
                              shall be null and void. The arbitrator may award declaratory or injunctive relief only in
                              favor of the individual party seeking relief and only to the extent necessary to provide
                              relief warranted by that party’s individual claim.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>15.&nbsp;Class Action Waiver</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              REGARDLESS OF THE FORUM, YOU AND&nbsp;TGC&nbsp;AGREE THAT EACH MAY BRING CLAIMS AGAINST
                              THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER
                              IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>16.&nbsp;Termination</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              Notwithstanding anything contained in these Terms, we reserve the right, without notice
                              and in our sole discretion, to terminate your right to access or use the TGC Services at
                              any time and for any or no reason, and you acknowledge and agree that in such event we
                              shall have no liability or obligation to you.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>17.&nbsp;Governing Law and Jurisdiction</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              TGC&nbsp;operates the TGC Services from&nbsp;Utah. These Terms and the transactions they
                              contemplate, including without limitation their interpretation, construction, performance
                              and enforcement, shall be governed by the laws of the State of&nbsp;Delaware, including
                              its statutes of limitations, but without reference to conflict or choice of law
                              provisions. The International Convention on the Sale of Goods, and other international
                              treaties that are not mandatory with respect to contracts made and performed entirely
                              in&nbsp;Arizona&nbsp;shall not apply.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>18.&nbsp;Notice</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              All notices, demands, or consents given by you under these Terms will be in writing and
                              will be deemed given when delivered to&nbsp;TGC&nbsp;at the following contact:
                              contact@brokenshepherds.com. Any notices to you may be made via either e-mail or postal
                              mail to the address in&nbsp;TGC’s&nbsp;records or via posting on the TGC Services. You
                              agree that any notices, agreements, disclosures or other communications that we send to
                              you electronically will satisfy any legal communication requirements, including, but not
                              limited to, that such communications be in writing.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Persons with disabilities who need assistance accessing these Terms may contact us as
                              provided for in this Section, and depending on your individual needs, we will grant
                              reasonable requests to furnish these Terms in an alternative format.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>19.&nbsp;Severability</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              If any term, clause or provision of these Terms is held invalid or unenforceable, then
                              that term, clause or provision will be severable from these Terms and will not affect the
                              validity or enforceability of any remaining part of that term, clause or provision, or any
                              other term, clause or provision of these Terms.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>20.&nbsp;Procedure for Making Claims of Copyright Infringement</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              If you believe in good faith that any of the content on the TGC Services infringes your
                              copyright, please provide our copyright agent the following written information: (a) an
                              electronic or physical signature of the person authorized to act on behalf of the owner of
                              the copyright interest; (b) a description of the copyrighted work that you claim has been
                              infringed; (c) a description of where the material that you claim is infringing is located
                              on the TGC Services; (d) your address, telephone number and email address; (e) a statement
                              by you that you have a good faith belief that the disputed use is not authorized by the
                              copyright owner, its agent or the law; and (f) a statement by you, made under penalty of
                              perjury, that the information in the notice is accurate and that you are the copyright
                              owner, or are authorized to act on behalf of the owner, of an exclusive right that is
                              allegedly infringed.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>TGC’s</strong>&nbsp;copyright agent for notice of claims of copyright infringement
                              can be reached as follows:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p class="" style="white-space: pre-wrap"><strong>TGC NOW, LLC</strong></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Attn: Executive Team
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Address: 104 E 600 S C823
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Heber City UT 84032
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Email: contact@brokenshepherds.com
                            </p>
                            <p class="" data-rte-preserve-empty="true" style="white-space: pre-wrap"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>21.&nbsp;Miscellaneous</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <br />
                              The TGC Services are hosted in the United States of America. If you are located outside of
                              the United States of America and you contact us, please be advised that any information
                              you provide to us will be transferred to the United States of America and that by
                              submitting information, you explicitly authorize such transfer. These Terms constitute the
                              entire agreement between you and&nbsp;TGC&nbsp;relating to your access to and use of the
                              TGC Services. These Terms, and any rights granted hereunder, may not be transferred or
                              assigned by you without the prior written consent of&nbsp;TGC. No waiver of any provision
                              of these Terms will constitute a waiver of such provision in any prior, concurrent or
                              subsequent circumstance, and&nbsp;TGC’s&nbsp;failure to assert any right or provision
                              under these Terms shall not constitute a waiver of such right or provision. Except as
                              otherwise provided herein, these Terms are intended solely for the benefit of the parties
                              and are not intended to confer third-party beneficiary rights upon any other person or
                              entity.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </main>
    </div>
  </body>
</html>
`;
